import { graphql } from "react-relay";

export const enableOrDisableTeamSyncForEventMutation = graphql`
  mutation EnableOrDisableTeamSyncForEventMutation($input: EnableOrDisableTeamSyncForEventInput!) {
    enableOrDisableTeamSyncForEvent(input: $input) {
      disabled
    }
  }
`;
